import React from "react";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsContext";

export default function SEO({ title, description, image, type = "website", jsonLd }) {
  const { settings } = useSettings();
  const name = settings.company_name || "GNONS Design & Construction";
  const fullTitle = title ? `${title} | ${name}` : `${name} | Architecture · Interior · Construction`;
  const desc = description || "GNONS Design & Construction — Architecture, Interior & Turnkey Construction in Indore, Madhya Pradesh.";
  const img = image || settings.hero_image || "/logo.png";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href={typeof window !== "undefined" ? window.location.href : ""} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
